package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import io.horion.cv.models.ExperienceState
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import org.jetbrains.compose.web.css.px

@Composable
fun ExperienceAccordionContent(
    onComplete: (String) -> Unit,
    onAddExperienceAndClose: (String) -> Unit
) {

    val cvViewModel = koinGet<CvViewModel>()
    val cvUiState = cvViewModel.cvUiState
    val experiencesFromVM = cvUiState.data.experiences

    LaunchedEffect(Unit) {
        if (experiencesFromVM.isEmpty()) {
            cvViewModel.updateExperience(0, io.horion.cv.api.datasource.cv.Experience("", "", "", "", "", listOf()))
            cvViewModel.editingExperienceId = "experience-0"
        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            },
        verticalArrangement = Arrangement.spacedBy(30.px)
    ) {
        experiencesFromVM.forEachIndexed { index, experience ->
            val tempId = "experience-$index"

            // Avant : chaque point était préfixé "1.", "2."... (visible et polluant
            // le texte à chaque réouverture) et toute la mise en forme HTML
            // (gras/italique/souligné) était perdue. Maintenant : chaque point
            // redevient un <div>, ce que produit naturellement l'éditeur —
            // donc la mise en forme réapparaît correctement à l'édition.
            val descriptionString = experience.description.joinToString(separator = "") { "<div>$it</div>" }

            val experienceState = remember(experience) {
                ExperienceState(
                    id = tempId,
                    poste = experience.post,
                    employeur = experience.enterprise,
                    ville = experience.city,
                    moisDebut = experience.started.split("-").getOrNull(0) ?: "",
                    anneeDebut = experience.started.split("-").getOrNull(1) ?: "",
                    moisFin = experience.ended.split("-").getOrNull(0) ?: "",
                    anneeFin = experience.ended.split("-").getOrNull(1) ?: "",
                    isOngoing = experience.ended == "En cours",
                    description = descriptionString
                )
            }
            GenericFormCard(
                item = experienceState,
                isEditing = cvViewModel.editingExperienceId == tempId,
                onEdit = { cvViewModel.editingExperienceId = tempId },
                onDelete = {
                    cvViewModel.deleteExperience(index)
                    if (experiencesFromVM.size <= 1) {
                        cvViewModel.updateExperience(0, io.horion.cv.api.datasource.cv.Experience("", "", "", "", "", listOf()))
                        cvViewModel.editingExperienceId = "experience-0"
                    } else {
                        cvViewModel.editingExperienceId = null
                    }
                },
                onComplete = {
                    cvViewModel.editingExperienceId = null
                },
                getSummary = { e ->
                    if (e.poste.isNotBlank() || e.employeur.isNotBlank()) {
                        SummaryData(
                            title = e.poste.ifBlank { "[Poste]" },
                            subtitle = e.employeur.ifBlank { "[Employeur]" }
                        )
                    } else null
                },
                getDefaultText = { "[Expérience]" },
                formContent = { state, onDel, onComp ->
                    ExperienceForm(
                        index = index,
                        state = state,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp
                    )
                }
            )
        }
        AddButton(
            text = "Ajouter une expérience professionnelle",
            onClick = {
                val nextIndex = experiencesFromVM.size
                cvViewModel.updateExperience(nextIndex, io.horion.cv.api.datasource.cv.Experience("", "", "", "", "", listOf()))
                cvViewModel.editingExperienceId = "experience-$nextIndex"
            }
        )
    }
}